import graph from "./graph";
import Delete from "./Delete";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { isEmptyObject } from "helpers/formatObject";
import { useLazyQuery } from "@apollo/client";
import {
  Card,
  Stack,
  Button,
  Typography,
  CardHeader,
  CircularProgress,
} from "@mui/material";

import {
  NewDialog,
  NewDialogTitle,
  NewDialogContent,
  NewDialogActions,
} from "components";
import Labs from "./Labs";
import Units from "./Units";
import Doctors from "./Doctors";

export default function Services({ refetch, plan, title = "خدمات" }) {
  const { id, related_to } = plan;
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState([]);
  const { userToken } = useSelector((state) => state.auth);
  const [fetchModel, { loading }] = useLazyQuery(graph.get.query);

  const onOpen = () => setOpen(true);
  const onClose = () => setOpen(false);

  const getModel = async () => {
    try {
      const { data } = await fetchModel({
        context: {
          serviceName: graph.get.serviceName,
          headers: {
            authorization: `Bearer ${userToken}`,
          },
        },
        variables: {
          plan_ids: id,
        },
      });
      if (!isEmptyObject(data)) {
        const res = data[graph.get.name].data;
        setFormData(res);
      }
    } catch (error) {}
  };

  useEffect(() => {
    open && getModel();
  }, [open]);

  return (
    <>
      <Button size="small" color="info" variant="outlined" onClick={onOpen}>
        ویرایش
      </Button>
      <NewDialog open={open} onClose={onClose}>
        <NewDialogTitle title={title} onClose={onClose} />
        <NewDialogContent isPopup>
          <Stack p={1} flex={1} rowGap={1} bgcolor="background.paper">
            {loading ? (
              <Stack
                rowGap={2}
                height="100%"
                alignItems="center"
                justifyContent="center"
              >
                <CircularProgress size={20} color="inherit" />
                <Typography
                  align="center"
                  variant="caption"
                  color="text.disabled"
                >
                  در حال بارگذاری...
                </Typography>
              </Stack>
            ) : (
              <List data={formData} refetch={onClose} />
            )}
          </Stack>
        </NewDialogContent>
        <NewDialogActions>
          {related_to !== "unit" && (
            <Units
              plan={plan}
              refetch={onClose}
              init={formData.filter((x) => x.unit).map((x) => x.unit)}
            />
          )}

          {related_to !== "lab" && (
            <Labs
              plan={plan}
              refetch={onClose}
              init={formData.filter((x) => x.lab).map((x) => x.lab)}
            />
          )}

          {related_to !== "doctor" && (
            <Doctors
              plan={plan}
              refetch={onClose}
              init={formData.filter((x) => x.doctor).map((x) => x.doctor)}
            />
          )}
        </NewDialogActions>
      </NewDialog>
    </>
  );
}

function List({ data = [], refetch }) {
  return data.map((model, i) => <Model key={i} {...model} refetch={refetch} />);
}

function Model({ id, lab, unit, doctor, servant, refetch }) {
  if (servant === "unit") {
    return (
      <Card>
        <CardHeader
          title={lab?.title || `${doctor?.firstname} ${doctor?.lastname}`}
          action={<Delete id={id} refetch={refetch} />}
        />
      </Card>
    );
  }

  if (servant === "lab") {
    return (
      <Card>
        <CardHeader
          title={unit?.title || `${doctor?.firstname} ${doctor?.lastname}`}
          action={<Delete id={id} refetch={refetch} />}
        />
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader
        title={lab?.title || unit?.title}
        action={<Delete id={id} refetch={refetch} />}
      />
    </Card>
  );
}
